module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("16TeT"))).then(() => parcelRequire('hEqeo'));